import { useIntl } from 'react-intl';
import { TableCells, TableColumn } from '@eas/common-web';

export function useColumns(): TableColumn<any>[] {
  const intl = useIntl();

  return [
    {
      datakey: 'identifier',
      name: intl.formatMessage({
        id: 'IP__TICKET__COLUMN__IDENTIFIER',
        defaultMessage: 'Číslo',
      }),
      width: 100,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
  ];
}
